var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DocSignDialog',{attrs:{"docInfo":_vm.ispezione,"docType":'ispezione'}})}
var staticRenderFns = []

export { render, staticRenderFns }